import { MISSION } from '../constants';
import SectionLabel from './section-label';

function MissionSection() {
  return (
    <section id="mission" className="bg-hub-paper px-5 py-20 md:py-28">
      <div className="mx-auto grid max-w-7xl gap-10 md:grid-cols-12 md:items-center">
        <div className="md:col-span-5">
          <SectionLabel eyebrow="Mission" title="Meaningful days are built through people, places, and purpose." />
        </div>
        <div className="md:col-span-7">
          <p className="text-2xl leading-10 text-hub-forest md:text-3xl md:leading-[1.45]">
            {MISSION}
          </p>
          <div className="mt-8 grid gap-4 sm:grid-cols-2">
            <div className="rounded-[2rem] bg-hub-cream p-6">
              <p className="font-display text-3xl font-bold text-hub-coral">Belong</p>
              <p className="mt-3 leading-7 text-hub-muted">Create consistent spaces where participants are known, welcomed, and included.</p>
            </div>
            <div className="rounded-[2rem] bg-hub-sage/25 p-6">
              <p className="font-display text-3xl font-bold text-hub-forest">Contribute</p>
              <p className="mt-3 leading-7 text-hub-muted">Shape outreach around real service, practical skills, and visible community value.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default MissionSection;
